export default __webpack_public_path__ + "files/e670ba3e5b184767c9b2a37d7b368d77.png";